import { defineAsyncComponent } from 'vue';

export const commentMicroFrontends = {
	CommentReactions: defineAsyncComponent(
		() => import('./components/CommentReactions.vue')
	),
};
export { CommentCount } from './components/CommentCount';
export { CommentCountSkeleton } from './components/CommentCount';
